module.exports = __webpack_public_path__ + "img/KEN_village.b8718a66.jpg";